import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

export { application }

// Setup global features
document.addEventListener('turbo:load', function() {

    // autohide minor alerts
    setTimeout(function(){
        document.querySelectorAll('.autohide-alert').forEach(function(el) {
            el.style.transition = 'opacity 2.5s'
            el.style.opacity = '0'
            setTimeout(function(){ el.remove() }, 2500)
        })
    }, 2000);

    // initialise tooltips
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(el) {
        new bootstrap.Tooltip(el, {placement: 'top', delay: { show: 50, hide: 100 }, container: 'body', boundary: 'window' })
    })

})

// After a bootstrap tab change, trigger a custom global event
// It will be picked up by dashboard map controllers to reload the shapes
// (Need to wait until tab is shown otherwise contents may not be visible yet)
document.addEventListener('shown.bs.tab', function (e) {
    if (e.target.matches('a[data-bs-toggle="tab"]')) {
        const event = new CustomEvent("tab-changed", {
            detail: { target: e.target, tabHref: e.target.getAttribute('href') }
        })
        window.dispatchEvent(event)
    }
})
